import { ICustomBinding } from '#/DefaultViewExtensionInterfaces';
import ComponentManager from '@/Management/ComponentManager';
import PrincipalHistorizationPreviewItemT from '@/Controls/PrincipalHistorizationPreviewItem';

export default class PrincipalHistorizationPreviewItemsBinding implements ICustomBinding {

    initBinding() {
        ko.bindingHandlers.principalHistorizationPreviewItems = {
            init: (element: HTMLElement, valueAccessor: () => any) => {
                let PrincipalHistorizationPreviewItem = ComponentManager.getControl<typeof PrincipalHistorizationPreviewItemT>('PrincipalHistorizationPreviewItem');

                let preview = $(element);
                let options = valueAccessor();
                let parent = options.parent;
                let items = options.items;

                function onItemsChange(items) {
                    preview.find('li').remove();
                    parent.elements = [];

                    for (let i = 0; i < items.length; i++) {
                        let principalHistorizationPreviewItem = new PrincipalHistorizationPreviewItem(items[i], $('<li>').appendTo(preview));
                        let tuple = principalHistorizationPreviewItem.getTuple();

                        parent.elements.push(principalHistorizationPreviewItem);
                    }
                }

                let subscription = items.subscribe(onItemsChange);
                ko.utils.domNodeDisposal.addDisposeCallback(preview[0], () => {
                    subscription.dispose();
                });
                onItemsChange(items());
            }
        };
    }
}